import Image from 'next/image'

import { config } from '../config'

import { Breadcrumbs } from '@components/Breadcrumbs'
import { useIsTablet } from '@hooks/use-media-query'

import {
  WrapperImage,
  Wrapper,
  TextWrapper,
  Title,
  SubTitle,
  BackgroundImage,
} from './styles'

const {
  header: { title, subTitle, illustration, illustrationMobile, background },
} = config

export function Header() {
  const isMobile = useIsTablet()

  return (
    <Wrapper>
      {!isMobile && <Breadcrumbs />}
      <TextWrapper>
        <Title as="h1">{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
      </TextWrapper>
      <WrapperImage>
        <Image {...(isMobile ? illustrationMobile : illustration)} />
      </WrapperImage>
      <BackgroundImage {...background} />
    </Wrapper>
  )
}
